// extracted by mini-css-extract-plugin
export default {"hero":"styles_hero__tvzi1"};